import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { finalize, first } from 'rxjs';
import { LoadingDefaults } from '../../../shared/models/loading-defaults.model';
import {
  ShiftResponse,
  ShiftsClient,
} from '../../../shared/services/api-client';
import { RplLoadingService } from '../../../shared/services/rpl-loading.service';

export const shiftResolverFactory = (
  shiftId: number,
): ResolveFn<ShiftResponse> => {
  return () => {
    const client = inject(ShiftsClient);
    const loadingService = inject(RplLoadingService);
    let loadingId: string | undefined;

    const timeout = setTimeout(() => {
      loadingId = loadingService.start();
    }, LoadingDefaults.StartIndicatorTimeout);

    return client.getShiftById(shiftId).pipe(
      first(),
      finalize(() => {
        clearTimeout(timeout);
        loadingService.end(loadingId);
      }),
    );
  };
};
